module.exports = __webpack_public_path__ + "img/Ressources_Iran_Oil.e0a151d0.png";